'use client';
import React, { useState, useEffect } from 'react';
import DynamicModal from './DynamicModal';
import { useFetcherCSR } from '@/lib/useFetcherCSR';

function InitialLoadingModals() {
  const [currentModalIndex, setCurrentModalIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [modalQueue, setModalQueue] = useState<any[]>([]);
  const [intervalTime, setIntervalTime] = useState(3);
  const { data } = useFetcherCSR(`/api/v2/business-settings`);

  useEffect(() => {
    // ✅ Check if modals already shown in this session
    const hasShownModal = sessionStorage.getItem('hasShownPopupModal');
    if (hasShownModal) return; // Skip if already shown this session

    if (data?.popup) {
      const sortedPopups = [...data.popup.data].sort(
        (a, b) => a.order_by - b.order_by
      );
      setModalQueue(sortedPopups);
      setIntervalTime(data.popup.interval || 3);
      setCurrentModalIndex(0);
      setShowModal(true);

      // ✅ Mark as shown for this session
      sessionStorage.setItem('hasShownPopupModal', 'true');
    }
  }, [data]);

  const handleClose = () => {
    setShowModal(false);

    if (currentModalIndex < modalQueue.length - 1) {
      // Show next modal after interval
      setTimeout(() => {
        setCurrentModalIndex((prev) => prev + 1);
        setShowModal(true);
      }, intervalTime * 1000);
    }
  };

  const currentModal = modalQueue[currentModalIndex] || {};

  const isImageOnly =
    currentModal.image &&
    !currentModal.title &&
    !currentModal.description &&
    !currentModal.button_name;

  return (
    <>
      {modalQueue.length > 0 && currentModalIndex < modalQueue.length && (
        <DynamicModal
          show={showModal}
          onHide={handleClose}
          title={currentModal.title || undefined}
          description={currentModal.description || undefined}
          imageUrl={currentModal.image || undefined}
          buttonText={currentModal.button_name || undefined}
          buttonLink={currentModal.route || '#'}
          imageOnly={isImageOnly}
        />
      )}
    </>
  );
}

export default InitialLoadingModals;

// 'use client';
// import React, { useState, useEffect } from 'react';
// import DynamicModal from './DynamicModal';
// import { useFetcherCSR } from '@/lib/useFetcherCSR';

// function InitialLoadingModals() {
//   const [currentModalIndex, setCurrentModalIndex] = useState(0);
//   const [showModal, setShowModal] = useState(false);
//   const [modalQueue, setModalQueue] = useState<any[]>([]);
//   const [intervalTime, setIntervalTime] = useState(3);
//   const { data } = useFetcherCSR(`/api/v2/business-settings`);

//   // Initialize modal queue when data loads
//   useEffect(() => {
//     if (data?.popup) {
//       const sortedPopups = [...data.popup.data].sort(
//         (a, b) => a.order_by - b.order_by
//       );
//       setModalQueue(sortedPopups);
//       setIntervalTime(data.popup.interval);
//       setCurrentModalIndex(0);
//       setShowModal(true); // Show first modal immediately
//     }
//   }, [data]);

//   // Handle modal close and queue next modal
//   const handleClose = () => {
//     setShowModal(false);

//     if (currentModalIndex < modalQueue.length - 1) {
//       // Show next modal after interval
//       setTimeout(() => {
//         setCurrentModalIndex((prev) => prev + 1);
//         setShowModal(true);
//       }, intervalTime * 1000);
//     }
//   };

//   // Get current modal data
//   const currentModal = modalQueue[currentModalIndex] || {};

//   // Determine if current modal should be image-only
//   const isImageOnly =
//     currentModal.image &&
//     !currentModal.title &&
//     !currentModal.description &&
//     !currentModal.button_name;

//   return (
//     <>
//       {modalQueue.length > 0 && currentModalIndex < modalQueue.length && (
//         <DynamicModal
//           show={showModal}
//           onHide={handleClose}
//           title={currentModal.title || undefined}
//           description={currentModal.description || undefined}
//           imageUrl={currentModal.image || undefined}
//           buttonText={currentModal.button_name || undefined}
//           buttonLink={currentModal.route || '#'}
//           imageOnly={isImageOnly}
//         />
//       )}
//     </>
//   );
// }

// export default InitialLoadingModals;
